import axios from '@/api/config';

const practice = {
    getPlanList(data) {
      return axios.get(`${process.env.BASE_URL}/practice/getPlanList`, {params: data});
    },
    pageList(data) {
      return axios.post(`${process.env.BASE_URL}/practice/pageList`,  data);
    },
    questionPageList(data) {
      return axios.post(`${process.env.BASE_URL}/practice/questionPageList`,  data);
    },
    addPracticeQuestionForSchedule(data) {
      return axios.post(`${process.env.BASE_URL}/practice/addPracticeQuestionForSchedule`,  data);
    },
    addPracticeQuestionForChapterId(data) {
      return axios.post(`${process.env.BASE_URL}/practice/addPracticeQuestionForChapterId`,  data);
    },
    deletePracticeItemByPractice(data) {
      return axios.delete(`${process.env.BASE_URL}/practice/deletePracticeItemByPractice`,  {data:data});
    },
    updatePracticeQuestionForSchedule(data) {
      return axios.post(`${process.env.BASE_URL}/practice/updatePracticeQuestionForSchedule`,  data);
    },
    updatePracticeQuestionForChapterId(data) {
      return axios.post(`${process.env.BASE_URL}/practice/updatePracticeQuestionForChapterId`,  data);
    },
    getPracticeListByScheduleId(data) {
      return axios.get(`${process.env.BASE_URL}/practice/getPracticeListByScheduleId`,  {params:data});
    },
    copyDefaultPractice(data) {
      return axios.get(`${process.env.BASE_URL}/practice/copyDefaultPractice`,  {params:data});
    },
    deletePracticeById(data) {
      return axios.delete(`${process.env.BASE_URL}/practice/deletePracticeById`,  {data:data});
    },
    active(data) {
      return axios.post(`${process.env.BASE_URL}/practice/active`,  data);
    },
    practiceDetailByQuestionId(data) {
      return axios.get(`${process.env.BASE_URL}/practice/practiceDetailByQuestionId`,   {params:data});
    },
    getTopExerciseListByTypeId(data) {
      return axios.get(`${process.env.BASE_URL}/practice/getTopExerciseListByTypeId`,   {params:data});
    },
    checkPracticeExercise(data) {
      return axios.get(`${process.env.BASE_URL}/practice/checkPracticeExercise`,   {params:data});
    },
}

export default practice;



// WEBPACK FOOTER //
// ./src/api/practice.js